import React from 'react';
import { Heart } from 'lucide-react';
import { Artwork } from '../../types';
import { useNavigate } from 'react-router-dom';
import { useWishlist } from '../../hooks/useWishlist';

interface ArtworkCardProps {
  artwork: Artwork;
}

export const ArtworkCard: React.FC<ArtworkCardProps> = ({ artwork }) => {
  const navigate = useNavigate();
  const { isWishlisted, toggleWishlist, loading } = useWishlist(artwork.id);

  const handleWishlistClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    toggleWishlist();
  };

  // ✅ Pick primary image safely
  const primaryImage =
    artwork.imageUrls && artwork.imageUrls.length > 0
      ? artwork.imageUrls[0]
      : artwork.imageUrl;

  return (
    <div
      onClick={() => navigate(`/artwork/${artwork.id}`)}
      className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow cursor-pointer"
    >
      {/* Image */}
      <div className="relative">
        <img
          src={primaryImage}
          alt={artwork.title}
          loading="lazy"
          className="w-full h-48 object-cover"
        />

        {/* Sponsored badge */}
        {artwork.isPromoted && (
          <div className="absolute top-2 left-2 bg-yellow-400 text-primary px-2 py-1 rounded-md text-xs font-semibold">
            Sponsored
          </div>
        )}

        {/* Wishlist */}
        <button
          onClick={handleWishlistClick}
          disabled={loading}
          className="absolute top-2 right-2 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 disabled:opacity-50"
        >
          <Heart
            size={18}
            className={
              isWishlisted
                ? 'text-red-500 fill-red-500'
                : 'text-gray-700'
            }
          />
        </button>
      </div>

      {/* Content */}
      <div className="p-3">
        <h3 className="font-semibold text-gray-800 truncate">
          {artwork.title}
        </h3>
        <p className="text-sm text-gray-500">
          by {artwork.artistName}
        </p>

        <div className="flex items-center justify-between mt-2">
          <p className="text-lg font-bold text-primary">
            ₹{artwork.price.toLocaleString()}
          </p>
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <span>👁 {artwork.views}</span>
            <span>❤️ {artwork.likes}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
